export default __webpack_public_path__ + "static/media/application-security.0910a77e.png";